'use strict';

import textStartLeftImg from '../images/text_start_left.png';
import textStartRightImg from '../images/text_start_right.png';
import btnEnterImg from '../images/btn_enter.png';
import btnEnterPersonalImg from '../images/btn_enter_personal.png';
import btnEnterSystemImg0 from '../images/btn_enter_system/0.png';
import btnEnterSystemImg1 from '../images/btn_enter_system/1.png';
import btnEnterSystemImg2 from '../images/btn_enter_system/2.png';
import btnEnterSystemImg3 from '../images/btn_enter_system/3.png';
import btnEnterSystemImg4 from '../images/btn_enter_system/4.png';
import btnEnterSystemImg5 from '../images/btn_enter_system/5.png';
import btnEnterSystemImg6 from '../images/btn_enter_system/6.png';
import btnEnterSystemImg7 from '../images/btn_enter_system/7.png';
import btnEnterSystemImg8 from '../images/btn_enter_system/8.png';
import btnEnterSystemImg9 from '../images/btn_enter_system/9.png';
import btnEnterSystemImg10 from '../images/btn_enter_system/10.png';
import btnEnterSystemImg11 from '../images/btn_enter_system/11.png';
import btnSkipImg from '../images/btn_skip.png';

import bgPrefaceImg from '../images/bg_preface.png';
import titleImg from '../images/title.png';
import prefaceImg from '../images/preface.png';
// import titlePrefaceImg from '../images/title_preface.png';
// import titlePrefaceCNImg from '../images/title_preface_cn.png';
// import titlePrefaceENImg from '../images/title_preface_en.png';
// import contentPrefaceImg from '../images/content_preface.png';
// import contentPrefaceCNImg from '../images/content_preface_cn.png';
// import contentPrefaceENImg from '../images/content_preface_en.png';

import btnLeftImg from '../images/btn_left.png';
import btnRightImg from '../images/btn_right.png';
import btnLeftBlueImg from '../images/btn_left_blue.png';
import btnLanCNImg from '../images/btn_lan_cn.png';
import btnLanENImg from '../images/btn_lan_en.png';
import lineGreenImg from '../images/line_green.png';

import systemNameImg0 from '../images/system_name/0.png';
import systemNameImg1 from '../images/system_name/1.png';
import systemNameImg2 from '../images/system_name/2.png';
import systemNameImg3 from '../images/system_name/3.png';
import systemNameImg4 from '../images/system_name/4.png';
import systemNameImg5 from '../images/system_name/5.png';
import systemNameImg6 from '../images/system_name/6.png';
import systemNameImg7 from '../images/system_name/7.png';
import systemNameImg8 from '../images/system_name/8.png';
import systemNameImg9 from '../images/system_name/9.png';
import systemNameImg10 from '../images/system_name/10.png';
import systemNameImg11 from '../images/system_name/11.png';

import btnUndergraduateImg from '../images/btn_undergraduate.png';
import btnGraduateImg from '../images/btn_graduate.png';
import btnRightGreenImg from '../images/btn_right_green.png';
import btnRightPinkImg from '../images/btn_right_pink.png';

import systemPrefaceImg0 from '../images/system_preface/0.png';
import systemPrefaceImg1 from '../images/system_preface/1.png';
import systemPrefaceImg2 from '../images/system_preface/2.png';
import systemPrefaceImg3 from '../images/system_preface/3.png';
import systemPrefaceImg4 from '../images/system_preface/4.png';
import systemPrefaceImg5 from '../images/system_preface/5.png';
import systemPrefaceImg6 from '../images/system_preface/6.png';
import systemPrefaceImg7 from '../images/system_preface/7.png';
import systemPrefaceImg8 from '../images/system_preface/8.png';
import systemPrefaceImg9 from '../images/system_preface/9.png';
import systemPrefaceImg10 from '../images/system_preface/10.png';
import systemPrefaceImg11 from '../images/system_preface/11.png';

import textSidebarImg0 from '../images/text_sidebar/0.png';
import textSidebarImg1 from '../images/text_sidebar/1.png';
import textSidebarImg2 from '../images/text_sidebar/2.png';
import textSidebarImg3 from '../images/text_sidebar/3.png';
import textSidebarImg4 from '../images/text_sidebar/4.png';
import textSidebarImg5 from '../images/text_sidebar/5.png';
import textSidebarImg6 from '../images/text_sidebar/6.png';
import textSidebarImg7 from '../images/text_sidebar/7.png';
import textSidebarImg8 from '../images/text_sidebar/8.png';
import textSidebarImg9 from '../images/text_sidebar/9.png';
import textSidebarImg10 from '../images/text_sidebar/10.png';
import textSidebarImg11 from '../images/text_sidebar/11.png';

import btnDepartmentsImg from '../images/btn_departments.png';
import btnChangeUndergraduateImg from '../images/btn_change_undergraduate.png';
import btnChangeGraduateImg from '../images/btn_change_graduate.png';
import btnStudentsImg from '../images/btn_students.png';


import bgImg from '../images/bg_wh.png';
import sidebarBgImg from '../images/sidebar_bg.png';

import tipMaskImg from '../images/tip_mask.png';
import iconSlideImg from '../images/icon_slide.png';
import btnCloseGreenImg from '../images/btn_close_green.png';
import btnClosePinkImg from '../images/btn_close_pink.png';
import textStartingImg from '../images/text_starting.png';
import textEndingImg from '../images/text_ending.png';

import btnPortfolioImg from '../images/btn_portfolio.png';
import btnClosePortfolioImg from '../images/btn_close_portfolio.png';
import btnLeftPortfolioImg from '../images/btn_left_portfolio.png';
import btnRightPortfolioImg from '../images/btn_right_portfolio.png';
// import btnShareImg from '../images/btn_share.png';
// import btnRectLeftImg from '../images/bg_rect_left.png';
// import btnRectRightImg from '../images/bg_rect_right.png';
import bgDotWorkInfoImg from '../images/bg_dot_work_info.png';

import numberRegionImg from '../images/number_region.png';
import numberRegionXml from '../images/number_region.xml';

import numberPortfolioImg from '../images/number_portfolio.png';
import numberPortfolioXml from '../images/number_portfolio.xml';

import timeFontImg from '../images/time_font.png';
import timeFontXml from '../images/time_font.xml';

import btnZoomInImg from '../images/btn_zoom_in.png';
import btnZoomOutImg from '../images/btn_zoom_out.png';
import iconZoomProgressImg from '../images/icon_zoom_progress.png';

import hotspotImg from '../images/hotspot.png';
import hotspotSlideImg from '../images/hotspot_slide.png';
import btnPlayImg from '../images/btn_play.png';

import iconVideoProgressImg from '../images/icon_video_progress.png';
import controllerPlayImg from '../images/controller_play.png';
import controllerPauseImg from '../images/controller_pause.png';
import controllerLoadingImg from '../images/controller_loading.png';

import startImg from '../archives/start.png';

var ScenePreload = new Phaser.Class({

  Extends: Phaser.Scene,

  initialize:

  function ScenePreload ()
  {
    Phaser.Scene.call(this, { key: 'scenePreload', active: false });

    this.photoSourcesLoaded = false;
    this.photoSourcesAdded = false;
  },

  init: function(params){
    this.sceneBoot = this.scene.get('sceneBoot');
    this.scaler = this.sceneBoot.scaler;

    this.params = params;
  },

  preload: function ()
  {

    if(this.params.personal) {
      console.log(this.params.personal);
      this.load.image(this.params.personal.texture, this.params.personal.path);  
    }
    this.load.image('text_start_left', textStartLeftImg);
    this.load.image('text_start_right', textStartRightImg);
    this.load.image('btn_enter', btnEnterImg);
    this.load.image('btn_enter_personal', btnEnterPersonalImg);
    this.load.image('btn_skip', btnSkipImg);

    var btnEnterSystemImgs = [
      btnEnterSystemImg0, btnEnterSystemImg1, btnEnterSystemImg2, btnEnterSystemImg3, btnEnterSystemImg4,
      btnEnterSystemImg5, btnEnterSystemImg6, btnEnterSystemImg7, btnEnterSystemImg8, btnEnterSystemImg9,
      btnEnterSystemImg10, btnEnterSystemImg11
    ];
    btnEnterSystemImgs.forEach((img, index) => {
      this.load.image('btn_enter_system_' + index, img);
    });

    this.load.image('bg_preface', bgPrefaceImg);
    this.load.image('title', titleImg);
    this.load.image('preface', prefaceImg);
    // this.load.image('title_preface', titlePrefaceImg);
    // this.load.image('title_preface_cn', titlePrefaceCNImg);
    // this.load.image('title_preface_en', titlePrefaceENImg);
    // this.load.image('content_preface', contentPrefaceImg);
    // this.load.image('content_preface_cn', contentPrefaceCNImg);
    // this.load.image('content_preface_en', contentPrefaceENImg);

    this.load.image('btn_left', btnLeftImg);
    this.load.image('btn_right', btnRightImg);
    this.load.image('btn_left_blue', btnLeftBlueImg);
    this.load.image('btn_lan_cn', btnLanCNImg);
    this.load.image('btn_lan_en', btnLanENImg);
    this.load.image('line_green', lineGreenImg);

    var systemNameImgs = [systemNameImg0, systemNameImg1, systemNameImg2, systemNameImg3, systemNameImg4,
      systemNameImg5, systemNameImg6, systemNameImg7, systemNameImg8, systemNameImg9,
      systemNameImg10, systemNameImg11];
    systemNameImgs.forEach((img, index) => {
      this.load.image('system_name_' + index, img);
    });

    this.load.image('btn_undergradute', btnUndergraduateImg);
    this.load.image('btn_graduate', btnGraduateImg);
    this.load.image('btn_right_green', btnRightGreenImg);
    this.load.image('btn_right_pink', btnRightPinkImg);

    var systemPrefaceImgs = [
      systemPrefaceImg0, systemPrefaceImg1, systemPrefaceImg2, systemPrefaceImg3,
      systemPrefaceImg4, systemPrefaceImg5, systemPrefaceImg6, systemPrefaceImg7,
      systemPrefaceImg8, systemPrefaceImg9, systemPrefaceImg10, systemPrefaceImg11
    ];
    systemPrefaceImgs.forEach((img, index) => {
      this.load.image('system_preface_' + index, img);
    });

    var textSidebarImgs = [
      textSidebarImg0, textSidebarImg1, textSidebarImg2, textSidebarImg3,
      textSidebarImg4, textSidebarImg5, textSidebarImg6, textSidebarImg7,
      textSidebarImg8, textSidebarImg9, textSidebarImg10, textSidebarImg11
    ];
    textSidebarImgs.forEach((img, index) => {
      this.load.image('text_sidebar_' + index, img);
    });

    this.load.image('btn_departments', btnDepartmentsImg);
    this.load.image('btn_change_undergraduate', btnChangeUndergraduateImg);
    this.load.image('btn_change_graduate', btnChangeGraduateImg);
    this.load.image('btn_students', btnStudentsImg);

    this.load.image('bg', bgImg);
    this.load.image('sidebar_bg', sidebarBgImg);
    this.load.image('tip_mask', tipMaskImg);
    this.load.image('icon_slide', iconSlideImg);
    this.load.image('btn_close_green', btnCloseGreenImg);
    this.load.image('btn_close_pink', btnClosePinkImg);
    this.load.image('text_starting', textStartingImg);
    this.load.image('text_ending', textEndingImg);

    this.load.image('btn_portfolio', btnPortfolioImg);
    this.load.image('btn_close_portfolio', btnClosePortfolioImg);
    this.load.image('btn_left_portfolio', btnLeftPortfolioImg);
    this.load.image('btn_right_portfolio', btnRightPortfolioImg);
    // this.load.image('btn_share', btnShareImg);
    // this.load.image('bg_rect_left', btnRectLeftImg);
    // this.load.image('bg_rect_right', btnRectRightImg);
    this.load.image('bg_dot_work_info', bgDotWorkInfoImg);
    this.load.bitmapFont('numberRegionFont', numberRegionImg, numberRegionXml);
    this.load.bitmapFont('numberPortfolioFont', numberPortfolioImg, numberPortfolioXml);

    this.load.bitmapFont('timeFont', timeFontImg, timeFontXml);
    
    this.load.image('btn_zoom_in', btnZoomInImg);
    this.load.image('btn_zoom_out', btnZoomOutImg);
    this.load.image('icon_zoom_progress', iconZoomProgressImg);

    // load hotspot
    this.load.image('hotspot', hotspotImg);
    this.load.image('hotspot_slide', hotspotSlideImg);
    this.load.image('btn_play', btnPlayImg);

    this.load.image('icon_video_progress', iconVideoProgressImg);
    this.load.image('controller_play', controllerPlayImg);
    this.load.image('controller_pause', controllerPauseImg);
    this.load.image('controller_loading', controllerLoadingImg);

    this.load.spritesheet('start', startImg, {frameWidth: 660, frameHeight: 660});

    this.scene.launch('sceneLoading');
    this.isReady = false;
    
    this.load.on('progress', function (progress, e){
      this.scene.get('sceneLoading').setLoadingProgress(parseInt(progress*100));
      if(progress >= 1) {
        this.isReady = true;
      }
    }, this);
    
  },

  create: function ()
  {
  },

  update: function(){
    if(this.isReady){
      this.isReady = false;

      if(this.textures.getTextureKeys().indexOf('start') >= 0 ) {
        this.scene.launch('sceneTitle');
        this.scene.launch('sceneEnter', this.params);
        this.scene.launch('sceneAnimation');
      }
    }

    // if(this.photoSourcesLoaded == false && this.checkLoading() == 1){
    //   this.photoSourcesLoaded = true;
    //   console.log('load complete##');
    // }
  },

});
export default ScenePreload;